// @ts-nocheck
import { MaskCurrencyBr } from './currency_br';
import { MaskCurrencyUs } from './currency_us';
import { MaskCpf } from './cpf';
import { MaskCnj } from './cnj';
import { MaskCnpj } from './cnpj';
import { MaskCpfCnpj } from './cpf_cnpj';
import { MaskPhoneBr } from './phone_br';
import { MaskEmail } from './email';
import { MaskPisPasep } from './pis_pasep';
import { MaskCEP } from './cep';
import { MaskDateBr } from './date';
import { MaskDateTimeBr } from './maskDateTimeBr';
import { MaskTime } from './time';
import { MaskPercents } from './percents';
import { MaskPercents_v2 } from './percents_v2';
import { MaskIP } from './ip';
import { MaskOnlyNumbers } from './onlyNumbers';
import { MaskIPv6 } from './ipv6';
import { MaskProtocolCGov } from './protocolCGov';
import { MaskDare } from './dare';
import { MaskGreRj } from './grerj';
import { MaskAgencyAccount } from './agencyAccount';
import { MaskAgencyDigit } from './agencyDigit';

export const maskList = {
	CURRENCY_BR: MaskCurrencyBr,
	IP: MaskIP,
	CURRENCY_US: MaskCurrencyUs,
	CPF: MaskCpf,
	CNJ: MaskCnj,
	CNPJ: MaskCnpj,
	CPF_CNPJ: MaskCpfCnpj,
	PHONE_BR: MaskPhoneBr,
	EMAIL: MaskEmail,
	PIS_PASEP: MaskPisPasep,
	ONLY_NUMBERS: MaskOnlyNumbers,
	CEP: MaskCEP,
	DATE_BR: MaskDateBr,
	DATE_TIME_BR: MaskDateTimeBr,
	TIME: MaskTime,
	PERCENTS: MaskPercents,
	PERCENTS_v2: MaskPercents_v2,
	IPV6: MaskIPv6,
	PROTOCOL_CONSUMIDOR_GOV: MaskProtocolCGov,
	DARE: MaskDare,
	GRERJ: MaskGreRj,
	AGENCY_ACCOUNT: MaskAgencyAccount,
	AGENCY_DIGIT: MaskAgencyDigit,
};
